import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'Before Physio Ready, I was spending 2-3 hours every weekend just catching up on documentation and creating home exercise programs for the upcoming week. This system gave me my weekends back. The templates are incredibly thorough and professional.',
  author: 'Sarah M.',
  role: 'PT, DPT, Outpatient Clinic Owner',
  location: 'Austin, TX'
}, {
  text: "The Exercise Prescription Library is a game-changer. I used to scramble to find the right progressions for my athletes. Now, I have a structured framework that I can rely on, which has significantly improved my patients' outcomes and my own confidence.",
  author: 'James L.',
  role: 'Sports Physical Therapist',
  location: 'Denver, CO'
}, {
  text: 'As a newer grad, the Treatment Planning Toolkit has been my lifeline. It bridges the gap between what we learned in school and the reality of a fast-paced clinic. I feel much more organized and prepared for every evaluation.',
  author: 'Emily R.',
  role: 'Orthopedic PT',
  location: 'Chicago, IL'
}, {
  text: 'I bought this for my entire clinic staff. The standardization it brought to our documentation and patient education is incredible. Our reassessments are faster, and patient compliance with home exercises has noticeably increased.',
  author: 'Michael T.',
  role: 'Rehabilitation Center Director',
  location: 'Boston, MA'
}, {
  text: "The bonuses alone are worth the price. The Clinic Productivity Planner helped me restructure my day so I'm no longer taking notes home. If you're in private practice, you need this system.",
  author: 'Jessica K.',
  role: 'Private Practice PT',
  location: 'Seattle, WA'
}];
export function Testimonials() {
  return <section className="py-14 px-4 sm:px-6 bg-brand-paper border-y border-gray-200" data-id="element-190" data-mp="1iuifi30jol80">
      <div className="text-center mb-12" data-id="element-191" data-mp="1nmabwu6dtl62">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-192" data-mp="1no3gm3xfpvbf">
          ⭐ 4.9/5 — VERIFIED PROFESSIONAL REVIEWS
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-193" data-mp="1sjpd2yf75jfw">
        {testimonials.map((t, i) => <div key={i} className={`bg-white border border-gray-100 p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow relative ${i === testimonials.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-194" data-mp="1oj5ju5xquzz1" data-mpi={i}>
            <Quote className="absolute top-6 right-6 w-12 h-12 text-brand-paper" data-id="element-195" data-mp="19rmsxd3cjl0w" />
            <div className="flex gap-1 mb-5" data-id="element-196" data-mp="14sk14ucdnbav">
              {[...Array(5)].map((_, s) => <Star key={s} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-197" data-mp="10sj9g809p3lv" data-mpi={s} />)}
            </div>
            <p className="text-brand-ink/90 font-medium mb-8 leading-relaxed text-sm italic relative z-10" data-id="element-198" data-mp="qtkajh5b0mc2">
              "{t.text}"
            </p>
            <div className="border-t border-gray-100 pt-5 flex items-center gap-4" data-id="element-199" data-mp="32g4a38wdqmo9">
              <div className="w-12 h-12 rounded-full bg-brand-navy text-white flex items-center justify-center font-bold text-lg shadow-inner" data-id="element-200" data-mp="37f7fwvk6owxa">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-201" data-mp="3ggyi3qfimlme">
                <p className="font-bold text-brand-navy text-sm mb-1" data-id="element-202" data-mp="3gekprpc7znij">
                  {t.author}
                </p>
                <p className="text-[11px] text-brand-ink/60 font-bold uppercase tracking-wide" data-id="element-203" data-mp="2opiqtj30kapu">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}